import axios from 'axios';

const axiosInstance = function () {
  return axios.create({
    baseURL: `https://happy.pulip.com`,
    timeout: 50000,
    // withCredentials: true,
    headers: {
      Accept: '*/*',
      'Content-Type': 'multipart/formed-data'
    }
  });
};
export function addNewsLetterAPI(payload) {
  return new Promise((resolve, reject) => {
    return axiosInstance()
      .post(`/api/brand/insertNewsletter`, payload)
      .then(response => resolve(response))
      .catch(err => reject(err));
  });
}

export function addRecruitAPI(payload) {
  return new Promise((resolve, reject) => {
    return axiosInstance()
      .post(`/api/brand/insertRecruit`, payload)
      .then(response => resolve(response))
      .catch(err => reject(err));
  });
}

export function addProjectAPI(payload) {
  return new Promise((resolve, reject) => {
    return axiosInstance()
      .post(`/api/brand/insertConsulting`, payload)
      .then(response => resolve(response))
      .catch(err => reject(err));
  });
}

export function addPdsAPI(payload) {
  return new Promise((resolve, reject) => {
    return axiosInstance()
      .post(`/api/brand/insertPds`, payload)
      .then(response => resolve(response))
      .catch(err => reject(err));
  });
}

/**
 * @workDate : 230829
 * @title : 방문자수 기록용 API
 * @code : 프로젝트문의(project), 프로젝트문의 등록버튼(project_submit), 채용문의(recruit), 채용문의 지원버튼(recruit_submit)
 *
 */
export const sendPageViewAPI = async code => {
  try {
    return axiosInstance().get(`/api/brand/pageview`, { params: { code } });
  } catch (err) {
    console.error(`sendPageViewAPI err : `, err);
    throw err;
  }
};
